/*
 * Vimeo ID dos vídeos dos modais. Tocam pelo Player AWS (playerType
 * 'modalVideo'), e o Vimeo fica de reserva. O backend só entrega o embed AWS
 * dos ids da lista dele (content `src/api/modalVideos/modalVideos.js`): vídeo
 * novo aqui precisa entrar lá também, senão toca sempre pelo Vimeo.
 */
export const MODAL_VIDEOS_VIMEO_ALLOWED = {
  MOSTRA_SEU_APROVA: {
    token: '1227123462',
    allowed: true,
  },
  CURSO_COMPLEMENTAR: {
    token: '1150141465',
    allowed: true,
  },
  REGIONAL: {
    token: '1150141585',
    allowed: true,
  },
  DISCIPLINA: {
    token: '1150141668',
    allowed: true,
  },
  TREINO_ELITE: {
    token: '1150141621',
    allowed: true,
  },
  ESQUADRAO_ELITE: {
    token: '1150141621',
    allowed: true,
  },
  MINHAS_REDACOES: {
    token: '1150141789',
    allowed: true,
  },
  TEMAS_REDACAO: {
    token: '1150141830',
    allowed: true,
  },
  SIMULADOR: {
    token: '1150141938',
    allowed: true,
  },
  PLANO_ADAPTATIVO: {
    token: '1150142020',
    allowed: false,//TODO: atualizar com novo video
  },
  CURSO_REGULAR: {
    token: '1150141376',
    allowed: true,
  },
  APROVA_LIVE: {
    token: '1150142164',
    allowed: true,
  },
  SIMULADO_ENEM: {
    token: '1150142248',
    allowed: true,
  },
  HOME_MINHA_AREA: {
    token: '1150142271',
    allowed: true,
  },
  LIVES: {
    token: '1150142118',
    allowed: true,
  },
};
